import {useState} from 'react';

import {Grid} from '@mui/material';

import {LeftPanelContent} from './components/LeftPanelContent';
import LogInForm from '../../../features/applicant/registration/components/LogInForm';
import {useCompleteLogin} from '../../../features/applicant/registration/hooks/useCompleteLogin';
import {OtpVerificationForm} from '../../../features/user/twoFactor/components/OtpVerificationForm';
import {User} from '../../../types/User';

export default function LogInPage() {
  // Held here and nowhere else: no cookie and no user context until the OTP validates, so a refresh
  // drops the half-finished sign-in and sends the user back to the password form.
  const [pendingUser, setPendingUser] = useState<User>();
  const {completeLogin} = useCompleteLogin();

  return (
    <Grid container justifyContent='center'>
      <LeftPanelContent
        titleTranslationKey={'registration.signUp.page.title'}
        subtitleTranslationKey={'registration.signUp.page.subtitle'}
      />
      {pendingUser ? (
        <OtpVerificationForm
          authToken={pendingUser.token}
          email={pendingUser.email}
          onVerified={() => completeLogin(pendingUser)}
          onBackToSignIn={() => setPendingUser(undefined)}
        />
      ) : (
        <LogInForm onTwoFactorRequired={setPendingUser} />
      )}
    </Grid>
  );
}
